export default __webpack_public_path__ + "static/zerowaste.tr-47bcef417dbfca85e72c4b848d4b2c8c.png";